// src/pages/LifeguardClasses.jsx
import CourseSchedule from '../components/CourseSchedule';

const sessions = [
  {
    title: "Bronze Medallion (Weekend)",
    date: "July 6 – July 14, 2025",
    time: "Sat & Sun, 10am–4pm",
    location: "Downtown Pool, Toronto",
    price: 180
  },
  {
    title: "National Lifeguard (Intensive)",
    date: "Aug 12 – Aug 16, 2025",
    time: "Mon–Fri, 9am–5pm",
    location: "PSA Facility North York",
    price: 350
  }
];

const LifeguardClasses = () => (
  <div className="bg-white text-gray-900 font-sans">
    <section className="pt-32 pb-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-blue-800">Lifeguard Classes</h1>
      <p className="text-lg mb-4">
        Prepare for a rewarding career in aquatics with our Lifeguard certification pathway...
      </p>
    </section>

    <CourseSchedule sessions={sessions} />
  </div>
);

export default LifeguardClasses;
